/**
 * ForwardingLocationPresenter
 *
 * --
 *
 */

import { useState } from 'react';
import { Content, Row, Col, Title, ModalLayout } from 'components';
import { Divider, Spin, Table, Button, Tag } from 'antd';
import ShopInformationList from 'routes/admin.routes/admin.orders/OrderList/components/ShopInformationList';
import { stringToMoneyFormat } from 'utils';
import DetailForwardingLocation from './components/DetailForwardingLocation';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { FORWARDING_TYPE } from 'constants/ForwardingConstants';
import dayjs from 'dayjs';
/**----------------------------------------
 * [Component] 배송지관리: 프레젠터
 * ----------------------------------------
 */
const ForwardingLocationPresenter = ({
  // onChange,
  permission,
  loading,
  currentShop,
  setCurrentShop,
  forwardingLocationList,
  setForwardingLocationList,
  modal,
  setModal,
  getLocationList,
}) => {
  /* ===== ROUTE ===== */

  /* ===== STATE ===== */
  const [editMode, setEditMode] = useState(false);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */

  /**
   *
   * --
   */
  const onSaved = (data, deleted) => {
    // 수정/생성 시
    if (deleted === false) {
      const fid = forwardingLocationList.findIndex(
        (i) => i.forwarding_location_id === data.forwarding_location_id
      );
      setForwardingLocationList([
        ...forwardingLocationList.slice(0, fid),
        data,
        ...forwardingLocationList.slice(fid + 1),
      ]);
      getLocationList();
      setEditMode(false);
    }
    // 삭제 시
    else {
      alert(data);
      setForwardingLocationList(
        forwardingLocationList.filter((i) => i.forwarding_location_id !== data)
      );
    }
    setModal(null);
  };
  /**
   * 액샐 다운로드
   * --
   */
  const handleDownloadXlsx = () => {
    const columns = [...col, { title: '', dataIndex: '' }];
    const rows = forwardingLocationList?.map((_item) => ({
      ..._item,
      business_hour: _item?.receive_information?.business_hour,
      manager_name: _item?.receive_information?.manager_name,
      type: FORWARDING_TYPE[_item?.type]?.label,
    }));
    downloadXlsx({
      columns: columns,
      rows: rows,
      fileName: '출고지',
    });
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  const col = [
    {
      title: '출고/수령지명',
      key: 'forwarding_name',
      dataIndex: 'forwarding_name',
      width: 250,
      align: 'center',
      fixed: 'left',
    },
    {
      title: '타입',
      key: 'type',
      dataIndex: 'type',
      width: 100,
      align: 'center',
      render: (type) => (
        <Tag color={FORWARDING_TYPE[type].color}>
          {FORWARDING_TYPE[type].label}
        </Tag>
      ),
      filters: Object.entries(FORWARDING_TYPE).map(([key, value]) => ({
        text: value.label,
        value: key,
      })),
      onFilter: (value, { type }) => type === value,
    },
    {
      title: '대표 연락처',
      key: 'phone',
      dataIndex: 'phone',
      width: 170,
      align: 'center',
      // render: (val) => stringToMoneyFormat(val),
    },
    {
      title: '담당자',
      key: 'manager_name',
      dataIndex: 'manager_name',
      width: 170,
      align: 'center',
      render: (_, v) => v?.receive_information?.manager_name ?? '',
    },
    {
      title: '배송비',
      key: 'delivery_price',
      dataIndex: 'delivery_price',
      width: 150,
      align: 'center',
      render: (v) => stringToMoneyFormat(v),
      sorter: (a, b) => a.delivery_price - b.delivery_price,
    },
    {
      title: '무료배송 기준금액',
      key: 'free_delivery_price',
      dataIndex: 'free_delivery_price',
      width: 170,
      align: 'center',
      render: (v) => stringToMoneyFormat(v),
      sorter: (a, b) => a.free_delivery_price - b.free_delivery_price,
    },
    {
      title: '반품 배송비',
      key: 'return_price',
      dataIndex: 'return_price',
      width: 150,
      align: 'center',
      render: (v) => stringToMoneyFormat(v),
      sorter: (a, b) => a.return_price - b.return_price,
    },
    {
      title: '교환 배송비',
      key: 'exchange_price',
      dataIndex: 'exchange_price',
      width: 150,
      align: 'center',
      render: (v) => stringToMoneyFormat(v),
      sorter: (a, b) => a.exchange_price - b.exchange_price,
    },
    {
      title: '영업시간',
      key: 'business_hour',
      dataIndex: 'business_hour',
      width: 150,
      align: 'center',
      render: (_, v) => `${v?.receive_information?.business_hour ?? ''}`,
    },
    {
      title: '주소',
      key: 'forwarding_address',
      dataIndex: 'forwarding_address',
      // width: 100,
      align: 'center',
      render: (v, row) => `${v}(${row.forwarding_address_detail})`,
    },
    {
      title: '등록일',
      key: 'created_at',
      dataIndex: 'created_at',
      // width: 100,
      align: 'center',
      render: (created_at) =>
        dayjs.unix(created_at).format('YYYY-MM-DD (HH:mm:ss)'),
      sorter: (a, b) => a.created_at - b.created_at,
    },
  ];
  return (
    <>
      <Content
        maxWidth={'100%'}
        height={'100%'}
        padding={20}
        backgroundColor={'none'}
      >
        <Title size={3} style={{ marginBottom: 10 }}>
          출고지관리
        </Title>

        <Spin spinning={loading}>
          <Row gutter={[1, 1]}>
            {/* === 업체목록: start === */}
            {permission === 'ADMIN' && (
              <Col x={4}>
                <Content
                  maxWidth={'100%'}
                  height={'100%'}
                  minHeight={540}
                  padding={0}
                  backgroundColor={'#fff'}
                  className="boxShadow"
                >
                  <ShopInformationList onChange={setCurrentShop} />
                </Content>
              </Col>
            )}
            {/* === 업체목록: end === */}

            {/* === 정산내역: start === */}
            <Col x={permission === 'ADMIN' ? 20 : 24}>
              <Content
                maxWidth={'100%'}
                height={'100%'}
                minHeight={540}
                // padding={0}
                backgroundColor={'#fff'}
                className="boxShadow"
              >
                <Title
                  size={4}
                  style={{ marginBottom: 5 }}
                  subButton={
                    <Button
                      type="primary"
                      onClick={() => {
                        setModal(true);
                        setEditMode(true);
                      }}
                    >
                      + 출고지 생성
                    </Button>
                  }
                >
                  출고지목록
                </Title>
                <Content maxWidth={'100%'} borderRadius={4} padding={0}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 20,
                    }}
                  >
                    <h4
                      style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                    >
                      총 <span>{forwardingLocationList?.length}</span>개
                    </h4>
                    <Button
                      style={{ marginRight: 8 }}
                      // size="large"
                      onClick={() => handleDownloadXlsx()}
                    >
                      엑셀로 다운로드
                    </Button>
                  </div>
                </Content>
                <Divider style={{ margin: '13px 0' }} />

                <Table
                  size="small"
                  bordered
                  dataSource={forwardingLocationList}
                  // pagination={{ pageSize: 100 }}
                  pagination={false} // 페이지네이션 비활성화
                  scroll={{ y: 680, x: 'max-content' }} // 테이블 자체 스크롤 설정
                  onRow={(record) => {
                    return {
                      onClick: () => {
                        setModal(record); // 행 클릭 시 이벤트 처리
                      },
                    };
                  }}
                  columns={col}
                />
              </Content>
            </Col>
            {/* === 정산내역: end === */}
          </Row>
        </Spin>
      </Content>

      {/* {console.log('f sadfdsa fsda fdsaf sadfa', currentShop)} */}
      {/* ===== 생성 및 상세보기: start ===== */}
      <ModalLayout
        type="drawer"
        maxWidth={780}
        title="출고지 상세"
        closable={true}
        isOpen={modal !== null}
        open={modal !== null}
        onCancel={() => {
          setModal(null);
          setEditMode(false);
        }}
      >
        {/*  */}
        {modal !== null && (
          <DetailForwardingLocation
            defaultData={modal}
            defaultEditMode={editMode}
            currentShop={currentShop}
            onSaved={onSaved}
          />
        )}
      </ModalLayout>
      {/* ===== 생성 및 상세보기: end ===== */}
    </>
  );
};

export default ForwardingLocationPresenter;
